import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import "./App.css";
import { Toaster } from "react-hot-toast";


import { SideBar } from "./component/SideBar";
import { Navbar } from "./component/Navbar";
import ProtectedRoute from "./component/ProtectedRoute";
import LoginPage from "./pages/LoginPage";

import Masters from "./pages/Masters";
import UserManagement from "./pages/UserManagement";
import CreateUser from "./component/Userform";
import DesignMaster from "./DatabaseMaster/Designmaster";

import CreateNewDesign from "./DatabaseMaster/CreateNewDesignTabs";
import SizeMaster from "./DatabaseMaster/SizeMaster";
import Dashborad from "./pages/Dashborad";
import VendorMaster from "./DatabaseMaster/Vendormaster";
import CreateVendor from "./component/CreateVendor";
import OrderManagement from "./pages/OrderManagement";
import CreateOrderPage from "./component/CreateOrder";

import OrderTracker from "./OrderTracker/OrderPgae";
import EmployeeDashboard from "./pages/EmployeeDashboard";

import AppInitializer from "./component/AuthStateCall";

import { useUserStore } from "./store/AuthUserStore";
import { Navigate } from "react-router-dom";
import FabricTypeMaster from "./DatabaseMaster/FabricTypeMaster";
import AstarMaster from "./DatabaseMaster/AstarMaster";
import CreateFabricTypePage from "./component/CreateFabricTypePage";
import CreateAstarPage from "./component/CreateAstarPage";
import TakaSticker from "./component/Sticker";

import GroupWorkDashboard from "./pages/GroupWorkDashboard";





const InitialPage = () => {
  const user = useUserStore((state) => state.user);

  if (user?.userRole === "employee" && user?.employeeType === "Group Work") {
    return <Navigate to="/group-work-dashboard" replace />;
  }

  if (user?.userRole === "employee") {
    return <Navigate to="/employeedashboard" replace />;
  }

  return <Dashborad />;
};



const EmployeeLayout: React.FC = () => (
  <div className="flex flex-col h-screen bg-gray-50">
    <Navbar onMenuClick={() => { }} />
    <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-auto">
      <Outlet />
    </main>
  </div>
);

const AppLayout: React.FC = () => {
  const [isSidebarOpen, setSideBarOpen] = useState<boolean>(false);

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      <Navbar onMenuClick={() => setSideBarOpen(!isSidebarOpen)} />
      <div className="flex flex-1 overflow-hidden">
        {isSidebarOpen && (
          <div
            className="fixed top-16 inset-x-0 bottom-0 bg-black bg-opacity-50 z-30 lg:hidden"
            onClick={() => setSideBarOpen(false)}
          ></div>
        )}
        <SideBar isOpen={isSidebarOpen} onClose={() => setSideBarOpen(false)} />
        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-auto ">
          {/* Child routes will be rendered here */}
          <Outlet />
        </main>
      </div>
    </div>
  );
};



const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AppInitializer />
      <Routes>
        {/* --- PUBLIC ROUTES --- */}
        <Route path="/login" element={<LoginPage />} />

        {/* --- PROTECTED LAYOUT ROUTE --- */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          {/* Nested routes that will be rendered inside AppLayout's <Outlet> */}
          {/* <Route index element={<Dashborad />} /> */}
          <Route index element={<InitialPage />} />
          <Route path="master" element={<Masters />} />
          <Route path="usermanagement" element={<UserManagement />} />
          <Route path="createuser" element={<CreateUser />} />
          <Route path="edit-user/:id" element={<CreateUser />} />
          <Route path="createVendor" element={<CreateVendor />} />
          <Route path="designmaster" element={<DesignMaster />} />
          <Route path="vendormaster" element={<VendorMaster />} />
          <Route path="sizemaster" element={<SizeMaster />} />
          <Route path="createnewdesign" element={<CreateNewDesign />} />
          <Route path="createnewdesign/:designId" element={<CreateNewDesign />} />
          <Route path="ordermanagement" element={<OrderManagement />} />
          <Route path="create-order" element={<CreateOrderPage />} />
          <Route path="edit-order/:orderId" element={<CreateOrderPage />} />
          <Route path="order-tracker/:id" element={<OrderTracker />} />
          {/* <Route path="employeedashboard" element={<EmployeeDashboard />} /> */}
          <Route path="fabric-type-master" element={<FabricTypeMaster />} />
          <Route path="astar-master" element={<AstarMaster />} />

          <Route path="create-fabric-type" element={<CreateFabricTypePage />} />
          <Route path="edit-fabric-type/:id" element={<CreateFabricTypePage />} />
          <Route path="create-astar" element={<CreateAstarPage />} />
          <Route path="edit-astar/:id" element={<CreateAstarPage />} />
          <Route path="/sticker" element={<TakaSticker fabricId={""} cn={""} date={""} designNo={""} meters={""} totalTaka={""} size={""} pattern={""} />} />

          {/* <Route path="group-work-dashboard" element={<GroupWorkDashboard />} /> */}


        </Route>
        <Route
          element={
            <ProtectedRoute>
              <EmployeeLayout />
            </ProtectedRoute>
          }
        >
          <Route path="employeedashboard" element={<EmployeeDashboard />} />
          <Route path="group-work-dashboard" element={<GroupWorkDashboard />} />
        </Route>

      </Routes>
      <Toaster position="top-right" reverseOrder={false} />
    </BrowserRouter>
  );
};

export default App;

